import { useMemo } from "react";
import { useParams, useRouteMatch } from "react-router";

import { SidebarNav } from "components/SidebarNav/SidebarNav";
import { TruLink } from "components/TruLink/TruLink";

import type { LocationDescriptor } from "history";
import type { FacilitiesState } from "../../scenes/Facility/models/facilitiesState";

export interface FacilityConfigurationMenuProps {
  facilities: FacilitiesState;
  hasChangesCallback?: (to: LocationDescriptor, clickHandler?: () => void) => void;
}

export const FacilityConfigurationMenu = ({
  facilities,
  hasChangesCallback,
}: FacilityConfigurationMenuProps) => {
  const { facilityViewId } = useParams();
  const match = useRouteMatch();

  const tertiaryActive = match.url.replace(/settings\/facility\/.*?\//i, "").toLowerCase();

  const currentFacility = useMemo(
    () => facilities.facilities.find((f) => f.ViewId === facilityViewId),
    [facilities.facilities, facilityViewId],
  );

  return (
    <SidebarNav heading={currentFacility?.Id || "Unknown"}>
      <TruLink
        hasChangesCallback={hasChangesCallback}
        isActive={tertiaryActive === "/general"}
        to={`/settings/facility/${facilityViewId}/general`}
        testId="link-general"
      >
        General
      </TruLink>
      <TruLink
        hasChangesCallback={hasChangesCallback}
        isActive={tertiaryActive === "/inpatient"}
        to={`/settings/facility/${facilityViewId}/inpatient`}
        testId="link-inpatient"
      >
        Inpatient
      </TruLink>
      <TruLink
        hasChangesCallback={hasChangesCallback}
        isActive={tertiaryActive === "/outpatient"}
        to={`/settings/facility/${facilityViewId}/outpatient`}
        testId="link-outpatient"
      >
        Outpatient
      </TruLink>
      <TruLink
        hasChangesCallback={hasChangesCallback}
        isActive={tertiaryActive.startsWith("/choice-lists")}
        to={`/settings/facility/${facilityViewId}/choice-lists`}
        testId="link-choice-lists"
      >
        Choice Lists
      </TruLink>
      <TruLink
        hasChangesCallback={hasChangesCallback}
        isActive={tertiaryActive === "/financialclasses"}
        to={`/settings/facility/${facilityViewId}/financialclasses`}
        testId="link-financialclasses"
      >
        Financial Classes
      </TruLink>
      <a href="#" disabled className="k-state-disabled" data-testid="link-field-settings">
        Field Settings
      </a>
    </SidebarNav>
  );
};
